import axios from 'axios';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var DEFAULT_CONFIG = {
    timeout: 0,
    withCredentials: true,
    validateStatus: function (status) { return status >= 200 && status < 599; },
};
var Http = /** @class */ (function () {
    function Http(baseUrl, config) {
        if (config === void 0) { config = {}; }
        this.isSetInstancesToken = false;
        this.source = axios.CancelToken.source();
        this.instanceTokenConfig = {
            authorizationTypeKey: 'Authorization',
            authorizationTokenKey: 'authorization_type',
            authorizationTypeValue: 0,
            authorizationTokenValue: '',
        };
        var axiosIns = axios.create(__assign({ baseURL: baseUrl }, DEFAULT_CONFIG, config));
        Http.INSTANCES[baseUrl] = axiosIns;
        this.axiosIns = axiosIns;
        // 设置拦截器
        var requestInterceptor = Http.INSTANCES_REQUEST_INTERCEPTORS[baseUrl] || Http.GLOBAL_REQUEST_INTERCEPTORS;
        var responseInterceptor = Http.INSTANCES_RESPONSE_INTERCEPTORS[baseUrl] || Http.GLOBAL_RESPONSE_INTERCEPTORS;
        if (requestInterceptor) {
            this.axiosIns.interceptors.request.use(requestInterceptor.resolve, requestInterceptor.reject);
        }
        if (responseInterceptor) {
            this.axiosIns.interceptors.response.use(responseInterceptor.resolve, responseInterceptor.reject);
        }
    }
    // 设置单个实例的token与tokenType
    Http.prototype.setInstanceTokenConfig = function (instanceTokenConfig) {
        this.isSetInstancesToken = true;
        this.instanceTokenConfig = __assign({}, this.instanceTokenConfig, instanceTokenConfig);
    };
    Http.prototype.request = function (opt) {
        var _a, _b;
        var _opt = Object.assign({}, opt);
        if (this.isSetInstancesToken) {
            var _c = this.instanceTokenConfig, authorizationTypeValue = _c.authorizationTypeValue, authorizationTokenValue = _c.authorizationTokenValue, authorizationTypeKey = _c.authorizationTypeKey, authorizationTokenKey = _c.authorizationTokenKey;
            if (authorizationTypeKey && authorizationTypeValue && authorizationTokenKey && authorizationTokenValue) {
                _opt.headers = __assign((_a = {}, _a[authorizationTypeKey] = authorizationTypeValue, _a[authorizationTokenKey] = authorizationTokenValue, _a), _opt.headers);
            }
        }
        else {
            var _d = Http.globalTokenConfig, authorizationTypeValue = _d.authorizationTypeValue, authorizationTokenValue = _d.authorizationTokenValue, authorizationTypeKey = _d.authorizationTypeKey, authorizationTokenKey = _d.authorizationTokenKey;
            if (authorizationTypeKey && authorizationTypeValue && authorizationTokenKey && authorizationTokenValue) {
                _opt.headers = __assign((_b = {}, _b[authorizationTypeKey] = authorizationTypeValue, _b[authorizationTokenKey] = authorizationTokenValue, _b), _opt.headers);
            }
            if (Http.globalHeaders) {
                console.log(_opt.headers);
                _opt.headers = __assign({}, _opt.headers, Http.globalHeaders);
            }
        }
        _opt.cancelToken = this.source.token;
        return this.axiosIns.request(_opt);
    };
    Http.prototype.abort = function () {
        this.source.cancel('API abort.');
    };
    Http.prototype.get = function (url, configs) {
        return this.request(__assign({ method: 'get', url: url }, configs));
    };
    Http.prototype.post = function (url, data, configs) {
        return this.request(__assign({ method: 'post', url: url,
            data: data }, configs));
    };
    Http.prototype.put = function (url, data, configs) {
        return this.request(__assign({ method: 'put', url: url,
            data: data }, configs));
    };
    Http.prototype.patch = function (url, data, configs) {
        return this.request(__assign({ method: 'patch', url: url,
            data: data }, configs));
    };
    Http.prototype.delete = function (url, configs) {
        return this.request(__assign({ method: 'delete', url: url }, configs));
    };
    Http.setGlobalHeaders = function (data) {
        Http.globalHeaders = data;
    };
    // 全局设置token与tokenType
    Http.setGlobalTokenConfig = function (globalTokenConfig) {
        Http.globalTokenConfig = __assign({}, Http.globalTokenConfig, globalTokenConfig);
    };
    // 获取相对应的实例
    Http.getInstances = function (key) {
        return Http.INSTANCES[key];
    };
    // 设置请求拦截器
    Http.setReqInterceptor = function (resolve, reject, url) {
        if (url) {
            // 单个实例
            Http.INSTANCES_REQUEST_INTERCEPTORS[url] = {
                resolve: resolve,
                reject: reject,
            };
        }
        else {
            // 全局
            Http.GLOBAL_REQUEST_INTERCEPTORS = {
                resolve: resolve,
                reject: reject,
            };
        }
    };
    // 设置响应拦截器
    Http.setResInterceptor = function (resolve, reject, url) {
        if (url) {
            // 实例
            Http.INSTANCES_RESPONSE_INTERCEPTORS[url] = {
                resolve: resolve,
                reject: reject,
            };
        }
        else {
            // 全局
            Http.GLOBAL_RESPONSE_INTERCEPTORS = {
                resolve: resolve,
                reject: reject,
            };
        }
    };
    Http.globalTokenConfig = {
        authorizationTypeKey: 'Authorization',
        authorizationTokenKey: 'authorization_type',
        authorizationTypeValue: 0,
        authorizationTokenValue: '',
    };
    Http.globalHeaders = {};
    Http.INSTANCES = {};
    Http.INSTANCES_REQUEST_INTERCEPTORS = {};
    Http.INSTANCES_RESPONSE_INTERCEPTORS = {};
    Http.GLOBAL_REQUEST_INTERCEPTORS = null;
    Http.GLOBAL_RESPONSE_INTERCEPTORS = null;
    return Http;
}());
//# sourceMappingURL=mlz_axios.js.map

//# sourceMappingURL=index.js.map

export default Http;
//# sourceMappingURL=ts-axios.es5.js.map
